export const GET_PROJECT_AUTHORITY = "GET_PROJECT_AUTHORITY";
export const GET_BD_USER = "GET_BD_USER";
export const GET_DEPARTMENT = "GET_DEPARTMENT";
export const GET_PROJECT_LIST = "GET_PROJECT_LIST";
export const ADD_TASK = "ADD_TASK";
export const GET_TASK = "GET_TASK";
export const GET_TASK_CATEGORY = "GET_TASK_CATEGORY";
export const GET_TASK_EXPORT = "GET_TASK_EXPORT";
export const GET_FEASIBILITY_REPORT_DETAIL = "GET_FEASIBILITY_REPORT_DETAIL";
export const UPDATE_TASK_OWNER = "UPDATE_TASK_OWNER";
export const UPDATE_TASK_START = "UPDATE_TASK_START";
export const UPDATE_TASK_COMPLETED = "UPDATE_TASK_COMPLETED";
export const GET_TASK_DETAIL = "GET_TASK_DETAIL";
export const GET_TASK_PROJECT_FILTER = "GET_TASK_PROJECT_FILTER";
export const GET_TASK_CATEGORY_FILTER = "GET_TASK_CATEGORY_FILTER";
export const GET_TASK_DEPARTMENT_FILTER = "GET_TASK_DEPARTMENT_FILTER";
export const GET_TASK_OWNER_FILTER = "GET_TASK_OWNER_FILTER";
export const GET_USER_DESIGNATION = "GET_USER_DESIGNATION";
export const GET_USER_ROLE_FUNCTIONALITY = "GET_USER_ROLE_FUNCTIONALITY";
export const UPDATE_USER_ROLE_FUNCTIONALITY = "UPDATE_USER_ROLE_FUNCTIONALITY";
export const CREATE_USER_ROLE_FUNCTIONALITY = "CREATE_USER_ROLE_FUNCTIONALITY";
export const GET_PUBLIC_HOLIDAY_LIST = "GET_PUBLIC_HOLIDAY_LIST";
export const GET_YEAR = "GET_YEAR";
export const GET_SALARY_ADVANCE = "GET_SALARY_ADVANCE";
export const GET_SALARY_ADVANCE_DEDUCTION_HISTORY =
  "GET_SALARY_ADVANCE_DEDUCTION_HISTORY";
export const GET_SALARY_ADVANCE_EXPORT = "GET_SALARY_ADVANCE_EXPORT";
export const GET_OUT_PASS = "GET_OUT_PASS";
export const GET_EMPLOYEE = "GET_EMPLOYEE";
export const GET_OUT_PASS_EXPORT = "GET_OUT_PASS_EXPORT";
export const GET_OUT_PASS_DETAILS = "GET_OUT_PASS_DETAILS";
export const GET_OUT_PASS_FILTER_DEPARTMENT = "GET_OUT_PASS_FILTER_DEPARTMENT";
export const GET_OUT_PASS_FILTER_EMPLOYEE = "GET_OUT_PASS_FILTER_EMPLOYEE";
export const GET_OUT_PASS_FILTER_STATUS = "GET_OUT_PASS_FILTER_STATUS";
export const GET_EMPLOYEE_ATTENDANCE = "GET_EMPLOYEE_ATTENDANCE";
export const GET_LEAVE_TYPE = "GET_LEAVE_TYPE";
export const GET_EMPLOYEE_CHECKIN = "GET_EMPLOYEE_CHECKIN";
export const GET_PETTY_CASH = "GET_PETTY_CASH";
export const GET_PETTY_CASH_MASTER_EXPORT = "GET_PETTY_CASH_MASTER_EXPORT";
export const GET_LEAVE_SUMMARY = "GET_LEAVE_SUMMARY";
export const GET_COMP_OFF_LEAVE_SUMMARY = "GET_COMP_OFF_LEAVE_SUMMARY";
export const GET_VEHICLE_SERVICE_REQUEST = "GET_VEHICLE_SERVICE_REQUEST";
export const GET_VECHICLE_TYPE = "GET_VECHICLE_TYPE";
export const GET_SERVICE_TYPE = "GET_SERVICE_TYPE";
export const GET_EMPLOYEE_ATTENDANCE_EXPORT = "GET_EMPLOYEE_ATTENDANCE_EXPORT";
export const GET_VEHICLE_SERVICE_REQUEST_EXPORT =
  "GET_VEHICLE_SERVICE_REQUEST_EXPORT";
export const GET_VEHICLE_NUMBER = "GET_VEHICLE_NUMBER";
export const CREATE_VEHICLE_SERVICE_REQUEST = "CREATE_VEHICLE_SERVICE_REQUEST";
export const GET_GST = "GET_GST";
export const GET_ASSEST_TYPE = "GET_ASSEST_TYPE";
export const GET_DESIGNATION = "GET_DESIGNATION";
export const GET_DESIGNATION_EXPORT = "GET_DESIGNATION_EXPORT";
export const GET_DEPARTMENT_MASTER = "GET_DEPARTMENT_MASTER";
export const GET_DEPARTMENT_EXPORT = "GET_DEPARTMENT_EXPORT";
export const GET_LEVEL = "GET_LEVEL";
export const GET_LEVEL_EXPORT = "GET_LEVEL_EXPORT";
export const GET_JOB_ROLE = "GET_JOB_ROLE";
export const GET_DEPARTMENT_DESIGNATION = "GET_DEPARTMENT_DESIGNATION";
export const GET_TASK_ACCOUNTABLE_FILTER = "GET_TASK_ACCOUNTABLE_FILTER";
export const GET_APPRAISAL_QUESTION = "GET_APPRAISAL_QUESTION";
export const GET_APPRAISAL_QUESTION_EXPORT = "GET_APPRAISAL_QUESTION_EXPORT";
export const GET_APPRAISAL_QUESTION_OPTION = "GET_APPRAISAL_QUESTION_OPTION";
export const GET_APPRAISAL_QUESTION_OPTION_EXPORT =
  "GET_APPRAISAL_QUESTION_OPTION_EXPORT";
export const GET_EMPLOYEE_APPRAISAL_QUESTION =
  "GET_EMPLOYEE_APPRAISAL_QUESTION";
export const GET_EMPLOYEE_APPRAISAL = "GET_EMPLOYEE_APPRAISAL";
export const GET_EMPLOYEE_APPRAISAL_EXPORT = "GET_EMPLOYEE_APPRAISAL_EXPORT";
export const GET_APPRAISAL = "GET_APPRAISAL";
export const GET_APPRAISAL_CATEGORY = "GET_APPRAISAL_CATEGORY";
export const GET_APPRAISAL_RATING = "GET_APPRAISAL_RATING";
export const GET_QUESTION = "GET_QUESTION";
export const GET_QUESTION_VALUE = "GET_QUESTION_VALUE";
export const GET_QUESTION_VALUE_SET = "GET_QUESTION_VALUE_SET";
export const GET_HR_LEAVE_TYPE = "GET_HR_LEAVE_TYPE";
export const GET_APPRAISAL_QUESTION_PRINT = "GET_APPRAISAL_QUESTION_PRINT";
export const GET_EMPLOYEE_APPRAISAL_QUESTION_PRINT =
  "GET_EMPLOYEE_APPRAISAL_QUESTION_PRINT";
export const GET_TO_DO_CATEGORY = "GET_TO_DO_CATEGORY";
export const GET_HR_APPRAISAL_QUESTION_DESIGNATION_FOR_UPDATE =
  "GET_HR_APPRAISAL_QUESTION_DESIGNATION_FOR_UPDATE";
export const GET_HR_APPRAISAL_QUESTION_DESIGNATION =
  "GET_HR_APPRAISAL_QUESTION_DESIGNATION";
export const GET_APPRAISAL_RATING_EXPORT = "GET_APPRAISAL_RATING_EXPORT";
export const GET_APPRAISAL_QUESTION_CATEGORY_FILTER =
  "GET_APPRAISAL_QUESTION_CATEGORY_FILTER";
export const GET_APPRAISAL_QUESTION_DEPARTMENT_FILTER =
  "GET_APPRAISAL_QUESTION_DEPARTMENT_FILTER";
export const GET_APPRAISAL_QUESTION_DESIGNATION_FILTER =
  "GET_APPRAISAL_QUESTION_DESIGNATION_FILTER";
export const GET_HR_APPRAISAL_QUESTION_OPTION =
  "GET_HR_APPRAISAL_QUESTION_OPTION";
export const GET_HR_APPRAISAL_QUESTION_OPTION_DETAIL =
  "GET_HR_APPRAISAL_QUESTION_OPTION_DETAIL";
export const GET_EMPLOYEE_FOR_APPRAISAL = "GET_EMPLOYEE_FOR_APPRAISAL";
export const GET_EMPLOYEE_APPRAISAL_FILTER_EMPLOYEE =
  "GET_EMPLOYEE_APPRAISAL_FILTER_EMPLOYEE";
export const GET_EMPLOYEE_APPRAISAL_FILTER_APPRAISAL =
  "GET_EMPLOYEE_APPRAISAL_FILTER_APPRAISAL";
export const GET_EMPLOYEE_DEPARTMENT_FOR_APPRAISAL =
  "GET_EMPLOYEE_DEPARTMENT_FOR_APPRAISAL";
export const GET_EMPLOYEE_APPRAISAL_FILTER_DEPARTMENT =
  "GET_EMPLOYEE_APPRAISAL_FILTER_DEPARTMENT";
export const GET_EMPLOYEE_APPRAISAL_FILTER_DESGINATION =
  "GET_EMPLOYEE_APPRAISAL_FILTER_DESGINATION";
export const GET_EMPLOYEE_APPRAISAL_DETAIL = "GET_EMPLOYEE_APPRAISAL_DETAIL";
export const GET_PENDING_TODO = "GET_PENDING_TODO";
export const GET_USER_ROLE_FUNCTIONALITY_DETAIL =
  "GET_USER_ROLE_FUNCTIONALITY_DETAIL";
export const GET_USER_ROLE_FUNCTIONALITY_FILTER_DEPARTMENT =
  "GET_USER_ROLE_FUNCTIONALITY_FILTER_DEPARTMENT";
export const GET_USER_ROLE_FUNCTIONALITY_FILTER_DESIGNATION =
  "GET_USER_ROLE_FUNCTIONALITY_FILTER_DESIGNATION";
//Hr Module User Bata
export const GET_USER_BATA = "GET_USER_BATA";
export const GET_USER_BATA_FILTER_USER = "GET_USER_BATA_FILTER_USER";
export const GET_USER_BATA_EXPORT = "GET_USER_BATA_EXPORT";

//full and final
export const GET_EMPLOYEE_FOR_PENDING_SETTLEMENT =
  "GET_EMPLOYEE_FOR_PENDING_SETTLEMENT";
export const GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_DEPARTMENT =
  "GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_DEPARTMENT";
export const GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_EMPLOYEE =
  "GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_EMPLOYEE";
export const GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_EXPORT =
  "GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_EXPORT";
export const GET_EMPLOYEE_FINAL_SETTLEMENT_DETAIL =
  "GET_EMPLOYEE_FINAL_SETTLEMENT_DETAIL";
export const GET_EMPLOYEE_FINAL_SETTLEMENT_PRINT =
  "GET_EMPLOYEE_FINAL_SETTLEMENT_PRINT";

//salary advance
export const GET_HR_SALARY_ADVANCE_DETAIL = "GET_HR_SALARY_ADVANCE_DETAIL";
export const GET_SALARY_FOR_SALARY_ADVANCE = "GET_SALARY_FOR_SALARY_ADVANCE";
export const GET_HR_SALARY_ADVANCE_FILTER_USER =
  "GET_HR_SALARY_ADVANCE_FILTER_USER";
export const GET_HR_SALARY_ADVANCE_FILTER_DEPARTMENT =
  "GET_HR_SALARY_ADVANCE_FILTER_DEPARTMENT";

//hr
export const GET_SETTING_ITEM = "GET_SETTING_ITEM";
export const GET_ADMIN_SETTING = "GET_ADMIN_SETTING";
export const GET_SETTING_ITEM_OPTION = "GET_SETTING_ITEM_OPTION";
export const GET_ADMIN_SETTING_VALUE = "GET_ADMIN_SETTING_VALUE";
export const GET_ADMIN_SETTING_DETAILS = "GET_ADMIN_SETTING_DETAILS";

//salary slip
export const GET_SALARY_SLIP = "GET_SALARY_SLIP";
export const GET_SALARY_SLIP_EXPORT = "GET_SALARY_SLIP_EXPORT";
export const GET_SALARY_SLIP_FILTER_EMPLOYEE =
  "GET_SALARY_SLIP_FILTER_EMPLOYEE";
export const GET_SALARY_SLIP_FILTER_EMPLOYEE_TYPE =
  "GET_SALARY_SLIP_FILTER_EMPLOYEE_TYPE";
export const GET_SALARY_SLIP_FILTER_DEPARTMENT =
  "GET_SALARY_SLIP_FILTER_DEPARTMENT";
export const GET_SALARY_SLIP_DETAIL = "GET_SALARY_SLIP_DETAIL";

export const GET_EMPLOYEE_APPRAISAL_QUESTION_DETAIL =
  "GET_EMPLOYEE_APPRAISAL_QUESTION_DETAIL";
export const GET_FORM_16 = "GET_FORM_16";
export const GET_FINANCIAL_YEAR_FOR_FORM = "GET_FINANCIAL_YEAR_FOR_FORM";
export const GET_FORM_16_FILTER_USER = "GET_FORM_16_FILTER_USER";
export const GET_FORM_16_FILTER_DEPARTMENT = "GET_FORM_16_FILTER_DEPARTMENT";
export const GET_FORM_16_FILTER_YEAR = "GET_FORM_16_FILTER_YEAR";

//vehicle fuel request
export const GET_FUEL_REQUEST = "GET_FUEL_REQUEST";
export const GET_FUEL_REQUEST_EXPORT = "GET_FUEL_REQUEST_EXPORT";
export const GET_FUEL_REQUEST_DETAIL = "GET_FUEL_REQUEST_DETAIL";
export const GET_VEHICLE_FOR_SERVICE = "GET_VEHICLE_FOR_SERVICE";
export const GET_ASSET_TYPE_FOR_SERVICE = "GET_ASSET_TYPE_FOR_SERVICE";
export const GET_ASSET_FOR_SERVICE = "GET_ASSET_FOR_SERVICE";
export const GET_CARD_FOR_SERVICE = "GET_CARD_FOR_SERVICE";
export const GET_VEHICLE_DETAIL_FOR_SERVICE = "GET_VEHICLE_DETAIL_FOR_SERVICE";
export const GET_VEHICLE_DETAIL_FOR_FUEL_REQUEST =
  "GET_VEHICLE_DETAIL_FOR_FUEL_REQUEST";
export const UPDATE_FUEL_REQUEST_FILTER_PROJECT =
  "UPDATE_FUEL_REQUEST_FILTER_PROJECT";
export const UPDATE_FUEL_REQUEST_FILTER_REQUEST_BY =
  "UPDATE_FUEL_REQUEST_FILTER_REQUEST_BY";
export const GET_SERVICE_TYPE_FOR_SERVICE = "GET_SERVICE_TYPE_FOR_SERVICE";
export const GET_VEHICLE_SERVICE_REQUEST_DETAIL =
  "GET_VEHICLE_SERVICE_REQUEST_DETAIL";
export const GET_VEHICLE_SERVICE_REQUEST_FILTER_REQUESTED_BY =
  "GET_VEHICLE_SERVICE_REQUEST_FILTER_REQUESTED_BY";
export const GET_VEHICLE = "GET_VEHICLE";
export const GET_VEHICLE_EXPORT = "GET_VEHICLE_EXPORT";
export const GET_VEHICLE_FILTER_OWNER = "GET_VEHICLE_FILTER_OWNER";
export const GET_PROFESSIONAL_TAX_MASTER = "GET_PROFESSIONAL_TAX_MASTER";
export const GET_PROVIDENT_FUND_MASTER = "GET_PROVIDENT_FUND_MASTER";
export const GET_ESI_MASTER = "GET_ESI_MASTER";
export const GET_HR_LEAVE_SUMMARY = "GET_HR_LEAVE_SUMMARY";
export const GET_HR_LEAVE_SUMMARY_TYPE = "GET_HR_LEAVE_SUMMARY_TYPE";
export const GET_LEAVE_SUMMARY_FILTER_EMPLOYEE =
  "GET_LEAVE_SUMMARY_FILTER_EMPLOYEE";
export const GET_HR_EMPLOYEE_PROFILE = "GET_HR_EMPLOYEE_PROFILE";
export const GET_SALARY_COMPONENT = "GET_SALARY_COMPONENT";
export const GET_SALARY_COMPONENT_EXPORT = "GET_SALARY_COMPONENT_EXPORT";
export const GET_HR_USER_SHIFT = "GET_HR_USER_SHIFT";
export const GET_PASSWORD_ITEM = "GET_PASSWORD_ITEM";
export const GET_COMPANY_PASSWORD = "GET_COMPANY_PASSWORD";
export const GET_STOCK_COMPANY = "GET_STOCK_COMPANY";
export const GET_COMPANY_PASSWORD_COMPANY_FILTER =
  "GET_COMPANY_PASSWORD_COMPANY_FILTER";
export const GET_COMPANY_PASSWORD_ITEM_FILTER =
  "GET_COMPANY_PASSWORD_ITEM_FILTER";
export const GET_VEHICLE_SERVICE_REQUEST_FILTER_COMPANY =
  "GET_VEHICLE_SERVICE_REQUEST_FILTER_COMPANY";
export const GET_USERS = "GET_USERS";
export const GET_MFA_PURPOSE = "GET_MFA_PURPOSE";
export const GET_USER_ROLE_MASTER = "GET_USER_ROLE_MASTER";
export const GET_EMPLOYEE_SHIFT_MASTER = "GET_EMPLOYEE_SHIFT_MASTER";
export const GET_STOCK_LOCATION_MASTER = "GET_STOCK_LOCATION_MASTER";
export const GET_USER_DETAIL = "GET_USER_DETAIL";
//TRAVEL PLANING
export const GET_TRAVEL_PLAN = "GET_TRAVEL_PLAN";
export const GET_TRAVEL_PLAN_DEATIL = "GET_TRAVEL_PLAN_DEATIL";
export const GET_DRIVER_FOR_TRAVEL_PLAN = "GET_DRIVER_FOR_TRAVEL_PLAN";
// Salart Structure Vishal
export const GET_SALARY_STRUCTURE = "GET_SALARY_STRUCTURE";
export const GET_COMPONENT_CALCULATION = "GET_COMPONENT_CALCULATION";
export const GET_SALARY_STRUCTURE_DETAIL = "GET_SALARY_STRUCTURE_DETAIL";
export const GET_HR_EMPLOYEE = "GET_HR_EMPLOYEE";
// Attendance Location Permission
export const GET_ATTENDANCE_LOCATION_PERMISSION =
  "GET_ATTENDANCE_LOCATION_PERMISSION";
export const GET_ATTENDANCE_LOCATION_PERMISSION_EXPORT =
  "GET_ATTENDANCE_LOCATION_PERMISSION_EXPORT";
export const GET_ATTENDANCE_LOCATION_PERMISSION_ITEM =
  "GET_ATTENDANCE_LOCATION_PERMISSION_ITEM";
export const GET_ATTENDANCE_LOCATION_PERMISSION_DETAIL =
  "GET_ATTENDANCE_LOCATION_PERMISSION_DETAIL";
export const GET_ATTENDANCE_LOCATION_PERMISSION_FILTER_LOCATION =
  "GET_ATTENDANCE_LOCATION_PERMISSION_FILTER_LOCATION";
export const GET_ATTENDANCE_LOCATION_PERMISSION_FILTER_USER =
  "GET_ATTENDANCE_LOCATION_PERMISSION_FILTER_USER";
//employee cheackin
export const GET_EMPLOYEE_CHECKIN_REFERENCE = "GET_EMPLOYEE_CHECKIN_REFERENCE";
export const GET_EMPLOYEE_CHECKIN_REFERENCE_EXPORT =
  "GET_EMPLOYEE_CHECKIN_REFERENCE_EXPORT";
// HR Employee Details
export const GET_HR_EMPLOYEE_BASIC_DETAILS = "GET_HR_EMPLOYEE_BASIC_DETAILS";
export const GET_HR_EMPLOYEE_BASIC_DETAILS_EXPORT =
  "GET_HR_EMPLOYEE_BASIC_DETAILS_EXPORT";
export const GET_HR_EMPLOYEMENT_TYPE = "GET_HR_EMPLOYEMENT_TYPE";
export const GET_HR_EMPLOYEE_EDUCATION_DETAILS =
  "GET_HR_EMPLOYEE_EDUCATION_DETAILS";
export const GET_HR_EMPLOYEE_EXPERIENCE_DETAILS =
  "GET_HR_EMPLOYEE_EXPERIENCE_DETAILS";
export const GET_HR_EMPLOYEE_RELATIONSHIP = "GET_HR_EMPLOYEE_RELATIONSHIP";
export const GET_HR_EMPLOYEE_COMPLIANCE = "GET_HR_EMPLOYEE_COMPLIANCE";
export const GET_EMPLOYEE_FAMILY = "GET_EMPLOYEE_FAMILY";
export const GET_HR_EMPLOYEE_DETAILS = "GET_HR_EMPLOYEE_DETAILS";
export const GET_HR_EMPLOYEE_STATUS = "GET_HR_EMPLOYEE_STATUS";
export const GET_HR_EMPLOYEE_FILTER_COMPANY = "GET_HR_EMPLOYEE_FILTER_COMPANY";
export const GET_HR_EMPLOYEE_FILTER_DEPARTMENT =
  "GET_HR_EMPLOYEE_FILTER_DEPARTMENT";
export const GET_HR_EMPLOYEE_FILTER_DESIGNATIONS =
  "GET_HR_EMPLOYEE_FILTER_DESIGNATIONS";
// AttendanceRegularization
export const GET_ATTENDANCE_REGULARIZATION = "GET_ATTENDANCE_REGULARIZATION";
export const GET_ATTENDANCE_REGULARIZATION_EXPORT =
  "GET_ATTENDANCE_REGULARIZATION_EXPORT";
export const GET_ATTENDANCE_REGULARIZATION_DETAIL =
  "GET_ATTENDANCE_REGULARIZATION_DETAIL";
export const GET_ATTENDANCE_REGULARIZATION_FILTER_DEPARTMENT =
  "GET_ATTENDANCE_REGULARIZATION_FILTER_DEPARTMENT";
export const GET_ATTENDANCE_REGULARIZATION_FILTER_EMPLOYEE =
  "GET_ATTENDANCE_REGULARIZATION_FILTER_EMPLOYEE";
export const GET_ATTENDANCE_REGULARIZATION_FILTER_STATUS =
  "GET_ATTENDANCE_REGULARIZATION_FILTER_STATUS";
// Hr Employee Attendance
export const GET_HR_EMPLOYEE_ATTENDANCE = "GET_HR_EMPLOYEE_ATTENDANCE";
export const GET_HR_EMPLOYEE_ATTENDANCE_FILTER_EMPLOYEE = "GET_HR_EMPLOYEE_ATTENDANCE_FILTER_EMPLOYEE";

export const GET_HR_EMPLOYEE_ATTENDANCE_EXPORT =
  "GET_HR_EMPLOYEE_ATTENDANCE_EXPORT";
export const GET_USER_CHECK_IN_TIME = "GET_USER_CHECK_IN_TIME";
//user check In
export const GET_USER_CHECK_IN = "GET_USER_CHECK_IN";
export const GET_USER_CHECK_IN_EXPORT = "GET_USER_CHECK_IN_EXPORT";
export const GET_USER_CHECK_IN_FILTER_USER = "GET_USER_CHECK_IN_FILTER_USER";
export const GET_USER_CHECK_IN_FILTER_DEPARTMENT =
  "GET_USER_CHECK_IN_FILTER_DEPARTMENT";
